import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { faStore, faTruck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import FormattedDate from "../../../../Shared/Components/FormatDate";
import { Order } from "../../Domain/Model/Order";
import OrderViewModel from "./OrderViewModel";

import { faBank, faCreditCard, faSpinner } from '@fortawesome/free-solid-svg-icons';
import * as signalR from "@microsoft/signalr";
import iconYape from '../../../../assets/img/icon-yape.png';
import { useToast } from "../../../../Shared/hook/useToast";
import connection, { startConnection } from "../../../../Shared/Utils/signalRService";
import { deliveryMethod, orderStatus, paymentMethodOrder, paymentReceipt } from "../enum/OrderEnums";


export const OrderDetail = () => {
    const { id } = useParams();
    const [stateOrder, setStateOrder] = useState("");
    const [stateOrderName, setStateOrderName] = useState("");
    const title = "Detalle de orden";
    // const toast = useRef<Toast>(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();
    // const [paymentReceipt, setPaymentReceipt] = useState("");

    const [visibleUpdateDate, setVisibleUpdateDate] = useState<boolean>(false);
    const [visibleUpdateState, setVisibleUpdateState] = useState<boolean>(false);
    const [visibleAttachVoucher, setVisibleAttachVoucher] = useState<boolean>(false);

    const [orderData, setOrderData] = useState<Order>();
    const [iconDeliverymethod, setIconDeliverymethod] = useState(faStore);

    const [deliveryDate, setDeliveryDate] = useState<Date | null>(new Date());
    const [fileVoucher, setFileVoucher] = useState<File | null>(null);

    const [ticketFile, setTicketFile] = useState<any>();
    const linkRef = useRef<HTMLAnchorElement>(null);

    const {
        getProductById,
        updateOrderStatus,
        updateDeliveryDate,
        addingInvoice,
        getOrderTicketById
    } = OrderViewModel();

    useEffect(() => {
        fetchOrder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const initializeConnection = () => {
        try {
            startConnection();
            console.log('Conexión establecida con el servidor SignalR.');
        } catch (error) {
            console.error('Error al iniciar la conexión:', error);
        }
    };
    initializeConnection();
    startConnection();
    connection.on('ReceiveNotification', (message) => {
        console.log('Mensaje recibido:', JSON.parse(message));
        const dataMessage = JSON.parse(message);
        showSuccess("Mensaje", dataMessage);

    });

    if (connection.state === signalR.HubConnectionState.Connected) {
        connection.stop();

    }


    const footerContentUpdateDate = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleUpdateDate(false)} className="p-button-text" />
            <Button label="Actualizar" icon="pi pi-check" onClick={() => { setVisibleUpdateDate(false); updatingDeliveryDate(orderData?.orderId ?? 0, deliveryDate ?? "") }} autoFocus severity="danger" />
        </div>
    );
    const footerContentUpdateState = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleUpdateState(false)} className="p-button-text" />
            <Button label="Aprobar" icon="pi pi-check" onClick={() => { setVisibleUpdateState(false); updateStatus(orderData?.orderId ?? 0, orderData?.orderStatus ?? 0, orderData?.deliveryMethod ?? 0) }} autoFocus severity="danger" />
        </div>
    );
    const footerContentAttachVoucher = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleAttachVoucher(false)} className="p-button-text" />
            <Button disabled={!fileVoucher} label="Guardar" icon="pi pi-check" onClick={() => { setVisibleAttachVoucher(false); sendVaucherAttached() }} autoFocus severity="danger" />
        </div>
    );


    const fetchOrder = async () => {
        try {
            if (id) {

                // setColorbtn("warning");

                //setPercentageDesc(0);
                const order: any = await getProductById(Number(id));
                const orderStatus = order.orderStatus;
                const deliveryMethodIcon = order.deliveryMethod === deliveryMethod.TIENDA ? faStore : faTruck;
                stateOrderClick(orderStatus);
                setIconDeliverymethod(deliveryMethodIcon);
                // setPaymentReceipt(order.paymentReceipt);


                if (order) {
                    setOrderData(order);
                } else {
                    console.error("Producto no encontrado.");
                }
            } else {

            }
        } catch (error) {
            console.error("Error al obtener el Product", error);
        }
    }

    // const show = (severity: any, summary: any, detail: any) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };

    const reject = () => {
        showWarn('Rechazada', 'has rechazado');
    }

    const confirmUpdateStatus = (orderId: number, state: number, deliveryMethod: number, paymentMethod: number) => {

        if (state === orderStatus.CONFIRMADO || state === orderStatus.ENVIADO || state === orderStatus.PENDIENTE || state === orderStatus.RECOJO) {
            confirmDialog({
                message: '¿Quieres actualizar la orden?',
                header: 'confirmar actualización',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-info',
                acceptLabel: 'Si',
                rejectLabel: 'No',
                accept: () => (paymentMethod === paymentMethodOrder.TRANSF_BANCARIA && state === orderStatus.PENDIENTE) ? setVisibleUpdateState(true) : updateStatus(orderId, state, deliveryMethod),
                reject
            });
        }
    };

    const updatingDeliveryDate = async (orderId: number, deliveryDate: any) => {
        console.log("deliveryDate", deliveryDate);
        const sendData = {
            orderId: orderId,
            deliveryDate: deliveryDate
        }
        const response = await updateDeliveryDate(sendData);
        if (response === true) {
            fetchOrder();
            showSuccess('Actualizando', 'La fecha de entrega se actualizo correctamente!');
        }
    }

    const sendVaucherAttached = async () => {

        const formData = new FormData();
        formData.append("OrderId", String(id));
        formData.append("Invoice", fileVoucher as File);

        const response = await addingInvoice(formData);

        if (response === true) {
            showSuccess('Actualizando', 'El Voucher se adjunto correctamente!');
            setFileVoucher(null);
        }

        // Debug
        for (const pair of formData.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }
    }

    const updateStatus = async (orderId: number, state: number, deliveryMethodData: number) => {

        let statusData = 0;


        const orderIdData = orderId;

        let sendData = {
            orderId: 0,
            orderStatus: 0
        }


        if (state === orderStatus.CONFIRMADO) {
            statusData = deliveryMethodData === deliveryMethod.TIENDA ? orderStatus.RECOJO : orderStatus.ENVIADO;
            sendData = {
                orderId: orderIdData,
                orderStatus: statusData
            }
            const updatingStatus = await updateOrderStatus(sendData);
            if (updatingStatus === true) {
                stateOrderClick(statusData);
                showSuccess('Actualizando', 'El estado se actualizo correctamente!');
            }
        }
        if (state === orderStatus.PENDIENTE) {
            statusData = orderStatus.CONFIRMADO;
            sendData = {
                orderId: orderIdData,
                orderStatus: statusData
            }
            const updatingStatus = await updateOrderStatus(sendData);
            if (updatingStatus === true) {
                stateOrderClick(statusData);
                showSuccess('Actualizando', 'El estado se actualizo correctamente!');
            }
        }

        if (state === orderStatus.RECOJO) {
            statusData = orderStatus.ENTREGADO;
            sendData = {
                orderId: orderIdData,
                orderStatus: statusData
            }
            const updatingStatus = await updateOrderStatus(sendData);
            if (updatingStatus === true) {
                stateOrderClick(statusData);
                showSuccess('Actualizando', 'El estado se actualizo correctamente!');
            }
        }
        if (state === orderStatus.ENVIADO || state === orderStatus.RECOJO) {
            statusData = orderStatus.ENTREGADO;
            sendData = {
                orderId: orderIdData,
                orderStatus: statusData
            }
            const updatingStatus = await updateOrderStatus(sendData);
            if (updatingStatus === true) {
                stateOrderClick(statusData);
                showSuccess('Actualizando', 'El estado se actualizo correctamente!');
            }
        }
    }

    const stateOrderClick = (state: number) => {

        switch (state) {
            case 0:
                setStateOrder("state-generado");
                setStateOrderName("Generado");
                break;
            case 1:
                setStateOrder("state-pendiente");
                setStateOrderName("Pendiente");
                break;
            case 2:
                setStateOrder("state-enviado");
                setStateOrderName("Enviado");
                break;
            case 3:
                setStateOrder("state-entregado");
                setStateOrderName("Entregado");
                break;
            case 4:
                setStateOrder("state-anulado");
                setStateOrderName("Anulado");
                break;
            case 5:
                setStateOrder("state-cancelado");
                setStateOrderName("Cancelado");
                break;
            case 6:
                setStateOrder("state-confirmado");
                setStateOrderName("Confirmado");
                break;
            case 7:
                setStateOrder("state-recojo");
                setStateOrderName("Recojo");
                break;
            default:
                setStateOrder("");
                setStateOrderName("");
                break;
        }

    }

    const paymentMethodOptions = (data: any) => {

        let config: any;
        let name: string = "";

        switch (data) {
            case 1:
                config = { iconName: faBank, style: 'bg-bank-content-orderdetail bg-bank' };
                name = "Transferencia bancaria";
                break;
            case 2:
                config = { iconName: faCreditCard, style: 'bg-credit-content-orderdetail bg-credit' };
                name = "Tarjeta de crédito";
                break;
            case 3:
                config = { style: 'bg-yape-content-orderdetail bg-yape' };
                name = "Pago por Yape";
                break;
            default:
                config = { iconName: faSpinner, style: 'fs-3' };
                break;
        }

        return (
            <div className={`content-icon-payment-method`} >
                <div className={`${config.style} `}>
                    {data === 3 ? (

                        <img style={{ "width": "40px" }} src={iconYape} alt="img-yape" />

                    ) : (

                        <FontAwesomeIcon icon={config.iconName} />
                    )}
                </div>
                <p>{name}</p>
            </div>
        );
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setFileVoucher(e.target.files[0]); // guardas el archivo en el state
        }
    };

    //   const uploadTicket = async () => {

    //     const response = await getOrderTicketById(Number(id));
    //     if(response?.length!==0){
    //         console.log("respuesta", response);
    //         setTicketFile(response);
    //     }
    //     return "";
    //   }

    const downloadTicket = async () => {
        const response = await getOrderTicketById(Number(id));

        const url = window.URL.createObjectURL(response);

        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank"
        //   a.download = "ticket.pdf";
        a.click();

        window.URL.revokeObjectURL(url);
    };

    return (
        <div className='container-fluid'>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Ordenes</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({ name: 'home' })} /></a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="/orders" className="text-danger">Ordenes</a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">

                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver las últimas ordenes generadas
                </div>
            </div>
            {/* <ConfirmDialog /> */}
            {/* <Toast ref={toast} /> */}
            <Dialog header="Comprobante de pago" visible={visibleUpdateState} style={{ width: '25vw' }} onHide={() => { if (!visibleUpdateState) return; setVisibleUpdateState(false); }} footer={footerContentUpdateState}>
                <section>
                    <img style={{ "width": "100%" }} src={orderData?.voucherUrl} alt="Comprobante de pago" />
                    <p>Fecha: <FormattedDate value={orderData?.deliveryDate ?? new Date()} /></p>
                </section>
            </Dialog>
            <div className="card p-5">
                <div className="row">
                    <section className="col-lg-12 mb-5 d-flex justify-content-between">

                        {orderData?.orderStatus !== orderStatus.ENTREGADO ?
                            <Button className="btn btn-dark" style={{ "height": "40px" }} label=" Cambiar fecha de entrega" icon={<FontAwesomeIcon icon={icon({ name: 'calendar-days' })} />} onClick={() => setVisibleUpdateDate(true)} />
                            : <div></div>
                        }
                        <Dialog header="Actualizar fecha de entrega" visible={visibleUpdateDate} style={{ width: '25vw' }} onHide={() => { if (!visibleUpdateDate) return; setVisibleUpdateDate(false); }} footer={footerContentUpdateDate}>
                            <section>
                                <label className="mb-1">Nueva fecha</label><br></br>
                                <Calendar className="d-flex" value={deliveryDate} onChange={(e) => setDeliveryDate(e.value!)}></Calendar>
                            </section>
                        </Dialog>
                        <section className="d-flex gap-20">
                            <article className="d-flex flex-column">
                                {paymentMethodOptions(orderData?.paymentMethod)}
                            </article>
                            <article className="d-flex flex-column cursor-btn" onClick={downloadTicket}>

                                <FontAwesomeIcon className="fs-1" icon={icon({ name: 'ticket' })} />
                                <span>Descargar<br></br> ticket</span>

                            </article>
                            {(orderData?.orderStatus !== orderStatus.GENERADO
                                && orderData?.orderStatus !== orderStatus.CANCELADO
                                && orderData?.orderStatus !== orderStatus.ANULADO
                            ) &&
                                <>
                                    <article className="d-flex flex-column cursor-btn" onClick={() => setVisibleAttachVoucher(true)}>
                                        <FontAwesomeIcon className="fs-1 text-danger" icon={icon({ name: 'file-arrow-up' })} />
                                        <span>Adjuntar<br></br> Comprobante</span>
                                    </article>
                                    <Dialog header="Adjuntar Comprobante" visible={visibleAttachVoucher} style={{ width: '25vw' }} onHide={() => { if (!visibleAttachVoucher) return; setVisibleAttachVoucher(false); }} footer={footerContentAttachVoucher}>
                                        <section>
                                            <label className="mb-1">Adjuntar Comprobante</label><br></br>
                                            <input type="file" accept="application/pdf" onChange={handleFileChange} />
                                        </section>
                                    </Dialog>
                                </>

                            }

                        </section>
                    </section>
                    <section className="col-lg-6 text-start">
                        <h3><FontAwesomeIcon className="fs-1" icon={icon({ name: 'user' })} /> {orderData?.customer.firstName + ' ' + orderData?.customer.lastName}</h3>
                        <ul>
                            <li><b>Email: </b>{orderData?.customer.email}</li>
                            <li><b>Nro contacto: </b><Link target="_blank" title="Contactar por WhatsApp" to={`https://api.whatsapp.com/send?phone=51${orderData?.contact}`}>{orderData?.contact}</Link></li>
                            <li><b>DNI: </b>{orderData?.customer.dni}</li>
                            {orderData?.paymentReceipt === paymentReceipt.FACTURA && <li><b>RUC:</b> {orderData?.ruc}</li>}
                        </ul>
                    </section>
                    <section className="col-lg-6 d-flex justify-content-end">
                        <div className="d-flex justify-content-between fs-5">
                            <div className="text-end pe-4" >
                                <p className="m-0"><b>Pedido:</b> </p>
                                <p><b>Fecha de creación:</b> </p>
                            </div>
                            <div className="text-end">
                                <p className="m-0 cod-order" style={{}}>{orderData?.orderCode}</p>
                                <p><FormattedDate value={orderData?.created ?? new Date()} /></p>
                            </div>
                        </div>
                    </section>
                    <section className="col-lg-12 row">
                        <div className="col-lg-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'calendar-days' })} /> Fecha entrega</p>
                                <p className="m-0"><FormattedDate value={orderData?.deliveryDate ?? new Date()} /> </p>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'file' })} /> Comprobante</p>
                                <p className="m-0">{orderData?.paymentReceipt === paymentReceipt.FACTURA ? "Factura" : "Boleta"}</p>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className={`card p-3 order-state ${stateOrder}`} onClick={() => { confirmUpdateStatus(orderData?.orderId ?? 0, orderData?.orderStatus ?? 0, orderData?.deliveryMethod ?? 0, orderData?.paymentMethod ?? 0) }}>
                                <p className="fw-bold m-0"><FontAwesomeIcon className="icon-entregado" icon={icon({ name: 'circle-check' })} /> Estado</p>
                                <p className="m-0">{stateOrderName}</p>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="card p-3">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={iconDeliverymethod} /> Tipo de entrega</p>
                                <p className="m-0">{orderData?.deliveryMethod === deliveryMethod.TIENDA ? "Recojo a Tienda" : "Envío a domicilio"}</p>
                            </div>
                        </div>
                    </section>
                    {
                        orderData?.deliveryMethod === deliveryMethod.TIENDA &&
                        <section className="col-lg-12 row mt-3 flex justify-content-center">
                            <div className="col-lg-3">
                                <div className="card p-3">
                                    <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'location-dot' })} /> Punto de Recogida</p>
                                    <p className="m-0 fw-bold fs-5">{orderData?.pickupLocation}</p>
                                </div>
                            </div>
                        </section>
                    }

                    {orderData?.deliveryMethod === deliveryMethod.ENVIO &&
                        <section className="col-lg-12 row mt-3 border-solid-content mb-4">


                            <div className="col-lg-4">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'location-arrow' })} /> Departamento</p>
                                <p className="m-0">{orderData?.addressDetail.department}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'location-arrow' })} /> Provincia</p>
                                <p className="m-0">{orderData?.addressDetail.province}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'location-arrow' })} /> Distrito</p>
                                <p className="m-0">{orderData?.addressDetail.district}</p>
                            </div>


                            <div className="col-lg-12 mt-4">
                                <p className="fw-bold m-0"><FontAwesomeIcon icon={icon({ name: 'location-dot' })} /> Dirección de Envío</p>
                                <p className="m-0">
                                    {orderData?.addressDetail.street} {orderData?.addressDetail.streetNumber}
                                    &nbsp;{orderData?.addressDetail.reference ? <>referencia ({orderData?.addressDetail.reference})</> : ""} {orderData?.addressDetail.recipient ? <><br></br><b>Recibe:&nbsp;</b></> : ""}{orderData?.addressDetail.recipient}
                                </p>
                            </div>
                        </section>
                    }
                    <div className="col-lg-12 mt-4 mb-4">
                        <p className="m-0 text-start"><b>Descripción adicional: </b> {orderData?.description} </p>
                    </div>
                    <hr></hr>
                    <h3 className="text-start">Detalle Pedido</h3>
                    <section className="col-lg-12 content-card-items ">
                        {
                            orderData?.details.map((d) => {
                                return <div className="card-item mb-2" key={d.product.productId}>
                                    <article className="d-flex">
                                        <div className="item-image me-4">
                                            <img src={d.product.mainPhoto} alt="img-item" />
                                        </div>
                                        <div className="item-text">
                                            <h4>{d.product.name}</h4>
                                            <section className="d-flex">
                                                <p className="fw-bold">{d.product.brand}</p>&nbsp;/&nbsp;
                                                <p className="fw-bold">{d.product.color}</p>
                                            </section>
                                        </div>
                                    </article>

                                    <article className="item-cant">
                                        <span>Cantidad</span>
                                        <br></br>
                                        {d.quantity}
                                    </article>
                                    <article className="item-price">
                                        <span>Precio Unid.</span>
                                        <br></br>
                                        S/ {d.price.toFixed(2)}
                                    </article>
                                    <article className="item-price">
                                        <span>Precio Total</span>
                                        <br></br>
                                        S/ {d.amount.toFixed(2)}
                                    </article>
                                </div>
                            })
                        }
                    </section>
                    <h3 className="text-start">Resumen de pago</h3>
                    <section className="border-solid-content">
                        <article className="d-flex justify-content-between fs-5">
                            <b>Subtotal:</b> <p>S/ {orderData?.subtotal.toFixed(2)}</p>
                        </article>
                        <article className="d-flex justify-content-between fs-5">
                            <b>Costo de envío:</b> <p>S/ {orderData?.shippingCost.toFixed(2)}</p>
                        </article>
                        <hr></hr>
                        <article className="d-flex justify-content-between fs-3">
                            <b>Total:</b> <p className="text-danger">S/ {orderData?.total.toFixed(2)}</p>
                        </article>
                    </section>
                </div>
            </div>
        </div>
    );
}